module.exports = __webpack_public_path__ + "static/tpp-icon-tripod-31d55d90d20f6d932e86361fdcf51abe.png";